import React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { LOADING } from "../../constants/common";
import { useNetwork } from "../../contexts/NetWork";
import paths from "../../constants/paths";
import { getProfileTarget } from "../../utils/profileTarget";
import Button from "@mui/material/Button";
import { ReactComponent as AddIcon } from "../../assets/Icons/add.svg";
import { trackClickEvent } from "../../mixpanel";

const UserVerticalCard = ({ data }) => {
  const { connectWithOthers, connectStatus } = useNetwork();

  const connect = () => {
    connectWithOthers({
      connected_user_id: data.id,
      account_type: localStorage.getItem("account_type") || data.account_type,
    });
    trackClickEvent("Trusted Relationship Made", {
      page: "Homepage",
      component: "Connection card",
      button: "connect",
    });
  };

  const isLoading = connectStatus === LOADING;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Avatar
          sx={{
            width: 48,
            height: 48,
          }}
          src={data?.main_image}
        />
        <Box>
          <Link
            href={(() => {
              const t = getProfileTarget(data);
              return paths.userProfile(
                encodeURIComponent(t.uuid),
                t.tid ? encodeURIComponent(t.tid) : "",
                encodeURIComponent(t.accountType),
              );
            })()}
            variant="body2"
            fontWeight={600}
            color="text.primary"
            textTransform="capitalize"
          >
            {data.first_name} {data.last_name}
            {JSON.parse(data.user_degree)?.length
              ? ", " +
                JSON.parse(data?.user_degree)
                  .map((value) => value.degree)
                  ?.join(", ")
              : ""}
          </Link>
          <Typography variant="body2" color="text.secondary">
            {data?.info?.headline}
          </Typography>
        </Box>
      </Box>
      <Button
        variant="outlined"
        style={{ borderRadius: "25px" }}
        onClick={connect}
        startIcon={<AddIcon />}
        disabled={isLoading}
      >
        Connect
      </Button>
    </Box>
  );
};

export default UserVerticalCard;
